import { KatapultElement, html } from '../../mixins/katapult-element.js';
import { mixinBehaviors } from '@polymer/polymer/lib/legacy/class.js';
import { DefaultComputedBindings } from '../../modules/DefaultComputedBindings.js';
import { KatapultJob } from '../../modules/katapult-job/KatapultJob.js';
import { KatapultModel } from '../../modules/katapult-model/KatapultModel.js';
import { html as litHtml } from 'lit';

import '@polymer/iron-selector/iron-selector.js';
import '@polymer/paper-progress/paper-progress.js';
import '@polymer/paper-spinner/paper-spinner.js';
import '@polymer/iron-icons/hardware-icons.js';
import { validateValue } from '../input-element/input-element.js';
import { GeofireTools } from '../../modules/GeofireTools.js';
import '../katapult-photo/katapult-photo.js';
import '../confirm-dialog/confirm-dialog.js';
import { GetNewAttributeValue } from '../../modules/GetNewAttributeValue.js';
import { CamelCase } from '../../modules/CamelCase.js';
import './mobile-compass.js';
import { AnimationManager } from '../katapult-model-editor/animationManager';
import { DataLayer } from '../../modules/DataLayer/DataLayer.js';
import { getAddressData } from '../katapult-maps-desktop/button_functions/get_address_data.js';
import { Path } from '../../modules/Path.js';
import { PickAnAttribute } from '../../modules/PickAnAttribute.js';
import { Clamp } from '../../modules/Clamp.js';
import '../katapult-elements/katapult-button.js';
import { KatapultDialog } from '../katapult-elements/katapult-dialog.js';
import { addFlagListener, removeFlagListener } from '../../modules/FeatureFlags.js';
import { listenToUploadEventsForNode, uploadPhoto } from './PhotoUpload/PhotoUploadService.js';
import { showPhotoUploadErrorToast } from './PhotoUpload/showPhotoUploadErrorToast.js';

/* global k, firebase, Polymer, appConfiguration */

class AssessAttributes extends mixinBehaviors([DefaultComputedBindings], KatapultElement) {
  static get template() {
    return html`
      <style>
        [hidden] {
          display: none !important;
        }
        #editPanel {
          position: absolute;
          background-color: white;
          width: 100%;
          max-width: 455px;
          right: -100%;
          top: 0;
          height: 100%;
          /*padding:24px;*/
          /* overflow:auto;*/
          box-sizing: border-box;
          transition: right 0.18s ease-in-out;
          z-index: 101;
          outline: none;
          display: flex;
          flex-direction: column;
        }
        #editPanel[opened=''] {
          /* Show the panel */
          right: 0;
        }
        #assessmentEditor {
          flex: 1;
          overflow-y: auto;
          overflow-x: hidden;
          position: relative;
          flex-basis: 0;
          text-align: center;
        }
        #assessmentEditor[scroll-mode=''] {
          display: block;
        }
        .assessmentStep,
        #assessmentNavigation {
          position: absolute;
          top: 0;
          bottom: 0;
          box-sizing: border-box;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          /* Invisible by default */
          opacity: 0;
          overflow-y: auto;
        }
        .stepContainer {
          width: 100%;
          max-height: 100%;
        }
        #assessmentEditor[is-transitioning=''] .assessmentStep {
          transition: none !important;
        }
        #assessmentEditor[scroll-mode=''] .assessmentStep {
          margin-top: 40px;
          display: inline-block;
          /* Unset any lingering styles from animation */
          opacity: 1;
          position: static !important;
          margin-bottom: 0;
          overflow-y: hidden;
        }
        #assessmentEditor[scroll-mode=''] .assessmentStep > p {
          margin: 8px 0;
        }
        #assessmentEditor h3 {
          font-weight: normal;
        }
        .timeBucketMessage {
          position: absolute;
          left: 50%;
          bottom: 100px;
          transform: translateX(-50%);
          padding: 5px 10px;
          border-radius: 50px;
          color: #fff;
          background-color: #007299;
          font-size: small;
        }
        .photoPrompt {
          display: flex;
          justify-content: center;
        }
        .photoPrompt > div {
          margin: 10px 15px;
          width: 150px;
        }
        .photoButton,
        .drawing-tool-button {
          width: 100px;
          height: 100px;
          border: 2px solid #007299;
          border-radius: 20px;
          color: #007299;
        }
        .photoButton > iron-icon,
        .drawing-tool-button > iron-icon {
          width: 50px;
          height: 50px;
          margin: 0;
        }
        .photoGroup {
          max-width: 360px;
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
        }
        .photoGroupButton {
          width: 80px;
          height: 80px;
          border: 2px solid #007299;
          border-radius: 20px;
          color: #007299;
        }
        .photoGroupButton > iron-icon {
          width: 40px;
          height: 40px;
          margin: 0;
        }
        .photoButton[checked],
        .photoGroupButton[checked] {
          border: unset;
          background-color: #007299;
          color: #fff;
        }
        .drawing-tool-button[disabled] {
          border: unset;
          background-color: var(--paper-grey-500);
          color: #fff;
        }
        .photo-upload-input {
          position: absolute;
          z-index: 12;
          top: 0;
          right: 0;
          margin: 0;
          padding: 0;
          width: 100%;
          height: 100%;
          cursor: pointer;
          opacity: 0;
        }
        #navigationButtons,
        #scrollModeCompleteButton {
          position: absolute;
          display: flex;
          align-items: center;
          gap: 8px;
          justify-content: space-between;
          width: 100%;
          bottom: 0;
          padding: 16px;
          box-sizing: border-box;
          background-color: #fff;
        }
        #navigationButtons katapult-button {
          flex: 1;
        }
        .blueProgress {
          --paper-progress-active-color: #007299;
        }
        .toastMessage {
          position: absolute;
          width: fit-content;
          bottom: 100px;
          left: 50%;
          transform: translateX(-50%);
          padding: 10px 10px;
          border-radius: 50px;
          color: #fff;
          background-color: #007299;
          opacity: 0;
          margin-bottom: -16px;
          transition:
            opacity 0.2s ease,
            margin-bottom 0.2s ease;
        }
        .toastMessage[opened] {
          opacity: 1;
          margin-bottom: 0;
          pointer-events: auto;
        }
        .buttons {
          margin-top: 16px;
          margin-bottom: 32px;
          display: flex;
          justify-content: space-between;
          padding-right: 16px;
          padding-left: 16px;
          box-sizing: border-box;
        }
        .title {
          font-size: 14pt;
          color: var(--primary-text-color);
          text-transform: uppercase;
        }
        .smallInfo {
          font-weight: lighter;
          font-size: 10pt;
          margin: 2px 0;
        }
        #editPanelInfo {
          /* height: 100%; */ /* Was a fix for Android mobile in some version of the code, no longer seems to work */
          background-color: #fff;
          z-index: 5;
          padding: 8px 16px;
          position: relative;
        }
        .wideButtonContainerPadding {
          padding: 0 16px 0 16px;
        }
        .buttonWide {
          display: inline-block;
          width: 100%;
          margin: 0 0 8px 0;
          border: 2px solid #007299;
          box-sizing: border-box;
          color: #007299;
          border-radius: 45px;
        }
        .buttonFlex {
          display: flex;
          align-items: center;
        }
        .buttonFilled {
          color: #fff;
          background-color: #007299;
        }
        .buttonMin {
          display: inline-block;
          margin-bottom: 8px;
          border: 2px solid #007299;
          color: #007299;
          border-radius: 45px;
        }
        .iron-selected {
          background-color: #007299;
          color: #fff;
          font-weight: normal;
        }
        .stepTools {
          display: flex;
          flex-direction: column;
          align-items: center;
          background-color: #ddd;
          border-radius: 20px;
        }
        .stepImage {
          width: 60px;
          height: 60px;
          margin: 0 16px;
          box-sizing: border-box;
          border-radius: 20px;
          padding: 10px;
          box-shadow: 0 0 10px #888;
        }
        .photoPromptCompass {
          --width: 60px;
          --height: 60px;
          --box-shadow: 0 0 10px #888;
        }
        .navigationButton {
          margin-left: 10px;
          width: 60px;
          height: 30px;
          padding: 5px;
          border-radius: 40px;
        }
        #deleteNodeButton {
          background-color: var(--paper-red-500);
          color: #fff;
          border: none;
          margin-right: 4px;
          display: flex;
        }
        #moveNodeButton {
          background-color: var(--paper-green-500);
          color: #fff;
          border: none;
          margin-left: 4px;
          display: flex;
        }
        #dialogCompass {
          --width: 300px;
          --height: 300px;
        }
        #imageViewer {
          display: flex;
          width: calc(100vw - 100px);
          height: calc(100vh - 100px);
        }
        .assessmentSelector {
          display: flex;
          flex-direction: column;
        }
        .closeImageViewer {
          position: absolute;
          top: 0;
          right: 0;
          transform: translate(50%, -100%);
          background-color: #fff;
          border-radius: 999px;
          box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
        }
        paper-table-scroll {
          --paper-table-scroll-dragging-item: {
            box-shadow: none;
          };
        }
        paper-table-scroll .dragging > div {
          @apply --shadow-elevation-2dp;
        }
        .required {
          color: var(--paper-red-500);
          font-weight: bold;
        }
        .stepCollapse {
          max-height: fit-content;
        }
        .stepWrapper {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;
        }
        .inputWrapper {
          overflow-y: auto;
          position: relative;
        }
        .headerWrapper {
          padding: 10px 20px;
          position: relative;
        }
        .scrollShadowTop {
          content: '';
          height: 10px;
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          background: linear-gradient(0deg, rgba(0 0 0 / 0%) 0%, rgba(0 0 0 / 20%) 100%);
        }
        .scrollShadowBottom {
          content: '';
          height: 10px;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(0deg, rgba(0 0 0 / 20%) 0%, rgba(0 0 0 / 0%) 100%);
        }
        .inputScroll {
          height: 100%;
          overflow-y: auto;
          padding: 0 20px;
        }
        .photo {
          height: 100px;
          width: 100px;
          @apply --shadow-elevation-2dp;
          margin: 4px;
          border-radius: 8px;
          border: none;
          transition: all 0.1s;
          --katapult-photo: {
            border-radius: 6px;
          };
          box-sizing: border-box;
          z-index: 0;
        }
        #setAddressDataSpinner {
          position: absolute;
          margin-top: 10px;
        }
      </style>
      <katapult-firebase-worker
        id="photos"
        path="photoheight/jobs/[[jobId]]/photos"
        data="{{jobPhotos}}"
        disabled?="[[!signedIn]]"
      ></katapult-firebase-worker>
      <div id="editPanel" opened$="[[panelIsOpen]]">
        <div id="editPanelInfo">
          <div style="display: flex; align-items: center;">
            <katapult-button
              id="navButton"
              iconOnly
              noBorder
              icon="[[if(hideNav, 'menu', 'arrow_back')]]"
              on-click="toggleHideNav"
              disabled="[[scrollMode]]"
            ></katapult-button>
            <span class="title">[[title]]</span>
            <div style="flex-grow: 1;"></div>
            <katapult-button iconOnly noBorder title="Close" icon="clear" on-click="closeEditPanel"></katapult-button>
          </div>

          <!-- Toolbar -->
          <template is="dom-if" if="{{showItemCoordinates(activeItem)}}">
            <div id="assessmentToolbar" style="display: flex;">
              <!-- TODO: Should update when the GPS is used to re-place the node -->
              <span class="smallInfo" style="margin: auto;">[[formatCoordinates(selectedNodeLatitude, selectedNodeLongitude)]]</span>
              <div style="flex: 1"></div>
              <template is="dom-if" if="[[!scrollMode]]">
                <katapult-button
                  iconOnly
                  noBorder
                  size="18"
                  color="#ddd"
                  class="navigationButton"
                  icon="fast_forward"
                  toggle-property="fastForward"
                  on-click="toggleSelfActive"
                ></katapult-button>
              </template>
              <katapult-button
                iconOnly
                noBorder
                size="18"
                color="#ddd"
                class="navigationButton"
                icon="swap_vert"
                toggle-property="scrollMode"
                on-click="toggleSelfActive"
              ></katapult-button>
            </div>
          </template>
        </div>

        <!-- Assessment -->
        <div id="assessmentEditor" scroll-mode$="[[scrollMode]]" is-transitioning$="[[modeTransitioning]]">
          <!-- Assessment Menu -->
          <div id="assessmentNavigation" style="margin-bottom: 0;">
            <div class="stepContainer">
              <h3>Assessment Menu</h3>
              <template is="dom-if" if="[[showEditButtonsInMenu]]">
                <div style="display: flex;" class="wideButtonContainerPadding">
                  <katapult-button
                    color="var(--paper-red-500)"
                    style="width: 100%; margin: 4px;"
                    noBorder
                    icon="delete"
                    on-click="deleteItem"
                    >Delete Node</katapult-button
                  >
                  <katapult-button
                    color="var(--paper-green-500)"
                    style="width: 100%; margin: 4px;"
                    noBorder
                    icon="map"
                    on-click="setLocationOnMap"
                    >Move Node</katapult-button
                  >
                </div>
              </template>
              <p>STEPS TAKEN</p>
              <div class="wideButtonContainerPadding">
                <template is="dom-repeat" items="{{getNavSteps(currentPath.*)}}">
                  <katapult-button
                    style="width: 100%; margin: 4px;"
                    textColor="#007299"
                    borderColor="#007299"
                    step_id="[[item._id]]"
                    on-click="jumpTo"
                    >[[item.title]]</katapult-button
                  >
                </template>
              </div>
            </div>
          </div>

          <!-- Attribute Panels -->
          <template
            is="dom-repeat"
            items="{{assessmentSteps}}"
            as="step"
            on-rendered-item-count-changed="attributePanelRenderedItemCountChanged"
          >
            <template is="dom-if" if="[[scrollMode]]">
              <iron-collapse opened="[[step.incompleteJump]]">
                <iron-icon icon="more-horiz"></iron-icon>
              </iron-collapse>
            </template>
            <iron-collapse class="stepCollapse" opened="[[!step.hidden]]">
              <div id="step_[[step._id]]" class="assessmentStep">
                <div class="stepWrapper">
                  <div class="headerWrapper">
                    <h3 style="text-transform: uppercase; margin: 0;">
                      <span>[[step.title]]</span>
                      <template is="dom-if" if="[[and(step.required, scrollMode)]]"><span class="required">*</span></template>
                    </h3>
                    <p style="margin: 8px 0;">[[step.prompt]]</p>
                    <div class="stepTools" hidden="[[!or(step.image, step.compass)]]">
                      <katapult-button
                        style="display: flex; align-items: center;"
                        noBorder
                        size="18"
                        toggle-property="stepToolsOpened"
                        icon="expand_less"
                        on-click="toggleSelfActive"
                        >Show Tools</katapult-button
                      >
                      <iron-collapse opened="[[stepToolsOpened]]">
                        <div style="padding: 8px; display: flex;">
                          <div class="stepImage" hidden="[[!step.image]]" on-click="openImageViewer">
                            <katapult-photo src="[[imageSource]]" background-color="#fff"></katapult-photo>
                          </div>
                          <mobile-compass class="photoPromptCompass" hidden="[[!step.compass]]"></mobile-compass>
                        </div>
                      </iron-collapse>
                    </div>
                  </div>

                  <div class="inputWrapper">
                    <div class="scrollShadowTop" hidden="[[scrollMode]]"></div>
                    <div class="inputScroll" on-scroll="_updateShadow">
                      <!-- Multi-select picklists -->
                      <template is="dom-if" if="[[showGuiElement(step, 'multi_dropdown', scrollMode)]]">
                        <paper-table-scroll
                          style="overflow-y: hidden;"
                          step_prop="[[step.property]]"
                          item_id="[[step.itemId]]"
                          on-sort-changed="multiSelectOrderChanged"
                        >
                          <template is="dom-repeat" items="[[step.valueArray]]">
                            <!--TODO: The styles for assessments are a bit of a mess... should be cleaned up-->
                            <paper-row style="padding: 4px; box-sizing: border-box; height: 100%;" slot="sortable" hidden="[[!item.$val]]">
                              <div style="margin-bottom: 0; flex-grow: 1;" class="buttonWide buttonFlex buttonFilled">
                                <iron-icon drag-handle icon="katapult-misc:drag-indicator" style="cursor: move; padding: 8px;"></iron-icon>
                                <div style="flex: 1;">[[item.$val]]</div>
                                <katapult-button
                                  iconOnly
                                  noBorder
                                  icon="clear"
                                  textColor="#fff"
                                  item_index="[[index]]"
                                  step_prop="[[step.property]]"
                                  item_id="[[step.itemId]]"
                                  on-click="handleMultiRemove"
                                ></katapult-button>
                              </div>
                            </paper-row>
                          </template>
                        </paper-table-scroll>
                        <template is="dom-if" if="[[calcNothingSelected(step.valueArray)]]">
                          <div style="color: #aaa;">(nothing selected)</div>
                        </template>

                        <p style="padding-top: 1em;  border-top: 1px solid #bbb;">Select all that apply</p>
                        <div style="display: block;">
                          <template
                            is="dom-repeat"
                            items="[[computeAttributeValues(otherAttributes, step.attribute, step.picklist, step.valueArray, step.multi_select, step.multi_duplicates)]]"
                          >
                            <katapult-button
                              textColor="#007299"
                              borderColor="#007299"
                              style="margin: 4px;"
                              step_prop="[[step.property]]"
                              item_id="[[step.itemId]]"
                              name$="[[item.value]]"
                              on-click="handleMultiAdd"
                              >[[or(item.label, item.value)]]</katapult-button
                            >
                          </template>
                        </div>
                      </template>

                      <!-- Single-select picklists -->
                      <template is="dom-if" if="[[showGuiElement(step, 'dropdown', scrollMode)]]">
                        <iron-selector
                          id="[[step.property]].[[step.itemKey]]"
                          attribute_name="[[step.attribute]]"
                          name$="[[step.itemId]]"
                          selected="[[step.value]]"
                          class="assessmentSelector"
                          attr-for-selected="name"
                          on-selected-changed="handleChange"
                        >
                          <template
                            is="dom-repeat"
                            items="[[computeAttributeValues(otherAttributes, step.attribute, step.picklist, step.valueArray, step.multi_select, step.multi_duplicates)]]"
                          >
                            <katapult-button textColor="#007299" borderColor="#007299" style="margin: 4px;" name$="{{item.value}}"
                              >[[or(item.label, item.value)]]</katapult-button
                            >
                          </template>
                        </iron-selector>
                      </template>

                      <!-- Checkbox -->
                      <template is="dom-if" if="[[showGuiElement(step, 'checkbox', scrollMode)]]">
                        <iron-selector
                          id="[[step.property]].[[step.itemKey]]"
                          attribute_name="{{step.attribute}}"
                          name$="{{step.itemId}}"
                          selected="[[makeBoolString(step.value)]]"
                          class="assessmentSelector"
                          attr-for-selected="name"
                          on-selected-changed="handleChange"
                        >
                          <katapult-button name="true" style="margin-bottom: 16px;">Yes</katapult-button>
                          <katapult-button name="false">No</katapult-button>
                        </iron-selector>
                      </template>

                      <!-- All Other Inputs -->
                      <template is="dom-if" if="[[showGuiElement(step, '$input', scrollMode)]]">
                        <input-element
                          id="[[step.property]].[[step.itemKey]]"
                          style="[[calcTableStyle(step.model.allow_scroll, step.model.table_width)]]"
                          attribute_name="[[step.attribute]]"
                          model="[[step.model]]"
                          other-attributes="[[otherAttributes]]"
                          user-group="[[userGroup]]"
                          disabled="[[readOnlyUser]]"
                          hide-on-disabled
                          firebase-disabled="[[disabled]]"
                          selected-picklist="[[step.picklist]]"
                          value="{{step.value}}"
                          mobile
                          on-input-element-change="handleChange"
                          name$="[[step.itemId]]"
                          no-label-float
                          camel-case
                          hide-attribute-name
                          is-mobile-assessment-input
                          record-laser-data="true"
                          job-creator="[[jobCreator]]"
                        ></input-element>
                      </template>

                      <!-- Button for quickly using the last entered value -->
                      <template is="dom-if" if="[[step.show_use_last_entered_option]]">
                        <katapult-button
                          style="margin-top:1em;"
                          on-tap="enterLastEnteredValue"
                          disabled="{{enterLastEnteredValueDisabled(step, previousValues.*)}}"
                          color="var(--secondary-color)"
                          >Use Last Entered Value</katapult-button
                        >
                      </template>

                      <!-- Photo Prompt -->
                      <template is="dom-if" if="[[showGuiElement(step, 'photo', scrollMode)]]">
                        <div class="photoPrompt">
                          <template is="dom-if" if="[[step.device_photo_allowed]]">
                            <div style="height:100%; width:100%">
                              <katapult-button
                                id="photoWithDevice"
                                step_title="{{step.title}}"
                                class="photoButton"
                                checked$="[[tookPhotosWithDevice(nodes.*, activeItem, step, _photoUploadProgress)]]"
                              >
                                <input class="photo-upload-input" type="file" accept="[[checkDevice()]]" on-change="fileInputChanged" />
                                <iron-icon
                                  icon="icons:done"
                                  hidden="[[!tookPhotosWithDevice(nodes.*, activeItem, step, _photoUploadProgress)]]"
                                ></iron-icon>
                                <iron-icon
                                  icon="hardware:smartphone"
                                  hidden="[[tookPhotosWithDevice(nodes.*, activeItem, step, _photoUploadProgress)]]"
                                ></iron-icon>
                              </katapult-button>
                              <p>TAKE PHOTOS WITH THIS DEVICE</p>
                              <template is="dom-if" if="[[step.classification]]">
                                <p><i>Photos taken will be automatically classified.</i></p>
                              </template>
                              <template is="dom-if" if="[[step.showClassifiedPhotos]]">
                                <div style="display: flex; flex-wrap: wrap; justify-content: center; padding: 12px;">
                                  <template is="dom-repeat" items="[[stepPhotoIds]]" as="photoId">
                                    <katapult-photo-viewer
                                      id="[[photoId]]"
                                      class="photo"
                                      load-data=""
                                      job-id="[[jobId]]"
                                      photo-id="{{photoId}}"
                                      size="small"
                                      style="margin-right:0.5em;"
                                      on-click="openFullscreenPhoto"
                                      no-fit=""
                                    ></katapult-photo-viewer>
                                  </template>
                                </div>
                              </template>
                            </div>
                          </template>
                          <template is="dom-if" if="[[step.external_photo_allowed]]">
                            <div>
                              <katapult-button
                                id="photoWithExternal"
                                step_title="{{step.title}}"
                                class="photoButton"
                                checked$="[[hasTimeBucket(step, timeBuckets.*)]]"
                                on-click="photosTakenExternal"
                              >
                                <iron-icon icon="icons:done" hidden$="[[!hasTimeBucket(step, timeBuckets.*)]]"></iron-icon>
                                <iron-icon icon="image:photo-camera" hidden$="[[hasTimeBucket(step, timeBuckets.*)]]"></iron-icon>
                              </katapult-button>
                              <p>PHOTOS TAKEN ON OTHER CAMERA</p>
                              <template is="dom-if" if="[[step.classification]]">
                                <p><i>Photos taken will need to be manually classified.</i></p>
                              </template>
                            </div>
                          </template>
                        </div>
                      </template>

                      <!-- GPS Set Location -->
                      <template is="dom-if" if="[[showGuiElement(step, 'set_location', scrollMode)]]">
                        <katapult-button style="margin-bottom:1em;" on-tap="setLocationOnMap" color="var(--secondary-color)" icon="map"
                          >Set Location on Map</katapult-button
                        >
                      </template>

                      <!-- Set Address Data -->
                      <template is="dom-if" if="[[showGuiElement(step, 'set_address_data', scrollMode)]]">
                        <katapult-button
                          style="margin-bottom: 1em;"
                          on-click="setAddressData"
                          color="var(--secondary-color)"
                          icon="[[getAddressButtonIcon(step, nodes.*)]]"
                          >Address Data</katapult-button
                        >
                        <paper-spinner id="setAddressDataSpinner"></paper-spinner>
                      </template>

                      <!-- Photo Group -->
                      <template is="dom-if" if="[[showGuiElement(step, 'photo_group', scrollMode)]]">
                        <div class="photoGroup">
                          <template is="dom-repeat" items="[[step.photo_prompts]]" as="prompt">
                            <div style="flex-basis: 50%; margin: 8px auto;">
                              <katapult-button
                                id="photoWithExternal"
                                prompt_title="[[prompt.title]]"
                                class="photoGroupButton"
                                checked$="[[hasTimeBucket(prompt, timeBuckets.*)]]"
                                on-click="photosTakenExternal"
                              >
                                <iron-icon icon="icons:done" hidden="[[!hasTimeBucket(prompt, timeBuckets.*)]]"></iron-icon>
                                <iron-icon icon="image:photo-camera" hidden="[[hasTimeBucket(prompt, timeBuckets.*)]]"></iron-icon>
                              </katapult-button>
                              <div style="margin-top: 8px;">
                                <span style="text-transform: uppercase;">[[prompt.title]]</span>
                                <template is="dom-if" if="[[prompt.required]]"><span style="color: var(--paper-red-500)">*</span></template>
                                <div style="margin: 4px 8px 0 8px; font-size: 14px;">[[prompt.prompt]]</div>
                              </div>
                            </div>
                          </template>
                        </div>
                      </template>

                      <!-- Drawing Tool -->
                      <template is="dom-if" if="[[showGuiElement(step, 'drawing_tool', scrollMode)]]">
                        <div>
                          <katapult-button
                            class="drawing-tool-button"
                            disabled="[[has(completedDrawingSteps, step._id)]]"
                            on-click="callStepDrawingTool"
                          >
                            <iron-icon icon="icons:create" hidden="[[has(completedDrawingSteps, step._id)]]"></iron-icon>
                            <iron-icon icon="icons:done" hidden="[[!has(completedDrawingSteps, step._id)]]"></iron-icon>
                          </katapult-button>
                        </div>
                        <template is="dom-if" if="[[has(completedDrawingSteps, step._id)]]">
                          <p>Drawing action completed</p>
                        </template>
                      </template>
                    </div>
                    <div class="scrollShadowBottom" hidden="[[scrollMode]]"></div>
                  </div>
                </div>
              </div>
            </iron-collapse>
          </template>

          <div id="assessmentCompleted" class="assessmentStep wideButtonContainerPadding" hidden$="[[scrollMode]]">
            <div class="stepContainer">
              <h3>Assessment Completed</h3>
              <katapult-button
                id="completedClose"
                class="buttonWide"
                style="display: flex;"
                textColor="#007299"
                icon="done"
                on-click="completeAssessment"
                >Close [[title]]</katapult-button
              >
            </div>
          </div>
        </div>

        <div id="scrollModeCompleteButton">
          <katapult-button
            on-click="completeAssessment"
            class="buttonWide buttonFlex buttonFilled"
            icon="done"
            style="margin: 0;"
            color="var(--secondary-color)"
            >Assessment Completed</katapult-button
          >
        </div>

        <div id="navigationButtons">
          <katapult-button
            id="backButton"
            icon="arrow_back"
            color="var(--secondary-color)"
            disabled="[[backButtonIsDisabled(pageIndex)]]"
            on-click="prevPage"
            >Back</katapult-button
          >
          <paper-progress class="blueProgress" value="[[pageIndex]]" max="[[assessmentSteps.length]]"></paper-progress>
          <katapult-button
            id="nextButton"
            icon="arrow_forward"
            color="var(--secondary-color)"
            reverse
            disabled="[[nextButtonIsDisabled(pageIndex, assessmentSteps.*, timeBuckets.*, completedDrawingSteps, _photoUploadProgress)]]"
            on-click="nextPage"
            >Next</katapult-button
          >
        </div>
        <div id="editorToast" class="toastMessage"></div>
      </div>

      <paper-dialog id="imageViewer">
        <div style="position: relative; width: 100%;">
          <katapult-button icon="clear" iconOnly dialog-dismiss class="closeImageViewer"></katapult-button>
          <katapult-photo id="imageViewerPhoto" src="[[imageSource]]" zoom></katapult-photo>
        </div>
      </paper-dialog>

      <!--This should give the user the option to cancel or delete incorrect data-->
      <confirm-dialog id="dataVeracityWarning" affirmative-text="Okay" dismissive-style="display: none;" modal></confirm-dialog>
    `;
  }

  // Fires: toast, prompt, cancel-prompt, secondary-prompt, cancel-secondary-prompt, zoom-to-active

  static get is() {
    return 'assess-attributes';
  }

  static get properties() {
    return {
      activeItem: {
        type: String,
        notify: true
      },
      activeCommand: {
        type: String,
        notify: true
      },
      activeButton: {
        type: String,
        notify: true
      },
      activeTool: {
        type: String,
        notify: true
      },
      activeButtonModel: {
        type: Object
      },
      pageIndex: {
        type: Number,
        value: -1,
        observer: 'pageIndexChanged'
      },
      color: {
        type: String,
        value: '#d23f31'
      },
      icon: {
        type: String,
        value: 'assessment'
      },
      editing: {
        type: String,
        value: ''
      },
      showNodeLocationUpdate: {
        type: Boolean,
        value: false
      },
      jobId: {
        type: String
      },
      modelDefaults: {
        type: Object,
        value: {}
      },
      nodes: {
        type: Object
      },
      connections: {
        type: Object
      },
      otherAttributes: {
        type: Object
      },
      jobStyles: Object,
      mappingButtons: {
        type: Object
      },
      previousValues: {
        type: Object,
        value: {}
      },
      readOnlyUser: Boolean,
      selectedNodeLatitude: Number,
      selectedNodeLongitude: Number,
      quickEditItems: {
        type: Array,
        value: []
      },
      uid: String,
      userGroup: String,
      disabled: Boolean,
      assessmentSteps: {
        type: Array,
        computed:
          'getAssessmentSteps(activeItem, quickEditItems, otherAttributes, mappingButtons, connections.*, nodes.*, scrollMode, tappedSetAddressButton.*)'
      },
      hideNav: {
        type: Boolean,
        value: true
      },
      showEditButtonsInMenu: {
        type: Boolean,
        computed: 'computeShowEditButtonsInMenu(userHasMobileAssessmentsRole, modelConfig.mobile_assessments.delete_and_move_menu_enabled)'
      },
      stepHistory: {
        type: Array,
        value: [0]
      },
      currentPath: {
        type: Array,
        value: [0]
      },
      timeBuckets: {
        type: Array,
        value: []
      },
      gotTimeSync: {
        type: Boolean,
        value: false
      },
      fastForward: {
        type: Boolean,
        value: false
      },
      scrollMode: {
        type: Boolean,
        value: false,
        observer: 'scrollModeChanged'
      },
      timeSyncDisabled: {
        type: Boolean,
        value: false
      },
      stepToolsOpened: {
        type: Boolean,
        value: true
      },
      inputModels: {
        type: Object
      },
      panelIsOpen: {
        type: Boolean,
        value: false
      },
      completedDrawingSteps: {
        type: Array,
        value: () => []
      }
    };
  }

  constructor() {
    super();

    // Defaults
    this.browserInfo = globalThis.browserInfo;
    this.panelIsOpen = false;
    this.pageIndex = -1;

    // Empty defaults for initialization
    this.nodes = {};
    this.jobStyles = {};
    this.jobPhotos = {};
    this.otherAttributes = {};
    this.mappingButtons = {};
    this.jobId = '';
    this.readOnlyUser = false;
    this.activeButton = '';
    this.assessmentSteps = [];
    this.currentPath = [0];
    this.stepHistory = [0];
    this.timeBuckets = [];
    this.completedDrawingSteps = [];
    this.previousValues = {};
    this.fastForward = false;
    this.featureFlagListeners = {};

    // Template helpers
    this.or = (a, b) => a || b;
    this.has = (a, b) => Array.isArray(a) && a.includes(b);
    this.if = (a, b, c) => (a ? b : c);
  }

  static get observers() {
    return [
      'updateNodeOrderAttribute(editing, activeItem, nodes.*, modelDefaults)',
      'updateTitle(editing, orderValue, editingJob, mainJobName, modelDefaults, activeButton)',
      'getImageSource(pageIndex, activeItem, assessmentSteps)',
      'getScrollMode(scrollModeConfig)',
      'registerAnimations(assessmentSteps.length)',
      'activeItemChanged(activeItem)',
      '_updateShadow(pageIndex, scrollMode)',
      'getPhotosForStep(pageIndex)',
      'updatePanelIsOpen(editing, activeTool)',
      'updatePhotoUploadEventListener(jobId, activeItem)',
      '_updateModelListeners(userGroup, signedIn)'
    ];
  }

  ready() {
    super.ready();
    this.set(`anim`, new AnimationManager(this));
  }

  connectedCallback() {
    super.connectedCallback();

    this.featureFlagListeners = {
      extendedAssessmentFFDelay: addFlagListener('extended_assessment_ff_delay', (enabled) => {
        this.extendedAssessmentFFDelay = enabled;
      })
    };
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    removeFlagListener('extended_assessment_ff_delay', this.featureFlagListeners.extendedAssessmentFFDelay);
    this._unsubscribeScrollMode?.();
  }

  _updateModelListeners(userGroup, signedIn) {
    this._unsubscribeScrollMode?.();
    this._unsubscribeScrollMode = null;
    if (!userGroup || !signedIn) return;
    this._unsubscribeScrollMode = KatapultModel.fromId(userGroup).onModelPathSnapshot(
      'models/config/mobile_assessments/scrollMode',
      (snapshot) => {
        this.scrollModeConfig = snapshot.val();
      }
    );
  }

  static get importMeta() {
    return import.meta;
  }

  get ffDelay() {
    return this.extendedAssessmentFFDelay ? 1000 : 100;
  }

  // Called when button is first selected from the tools menu
  init(button) {
    this.activeCommand = 'select';
    this.dispatchEvent(new CustomEvent('prompt', { detail: { text: `Select Item To ${this.readOnlyUser ? 'View' : 'Assess'}` } }));
    this.dispatchEvent(new CustomEvent('cancel-secondary-prompt'));
  }

  checkDevice() {
    return navigator?.userAgentData?.platform?.toLowerCase() == 'android' ? 'image/*,android/force-camera-workaround' : 'image/*';
  }

  updatePanelIsOpen() {
    this.panelIsOpen = !!this.editing && this.activeTool == 'assessAttributes';

    // If we are opening the panel and the assessment has not been started, start it
    if (this.panelIsOpen && this.pageIndex < 0) this.pageIndex = 0;

    // Update shadow to clear any lingering shadows
    this._updateShadow();
  }

  /**
   * Get an array of photo classification attributes for the given assessment step.
   * @param {?Object} assessmentStep The assessment step object.
   * @returns {true|Record<string, ''>|null} Returns null if no classification, true if no attributes, or an object with attribute keys and empty string values.
   * @throws {Error} If input models are not loaded.
   */
  getPhotoClassificationForAssessmentStep(assessmentStep) {
    // Error if input models are not loaded.
    const inputModels = this.inputModels;
    if (!inputModels) throw new Error('Input models are not loaded yet');

    // Return nothing if this assessment step does not specify a photo classification.
    const classification = assessmentStep?.classification;
    if (!classification) return null;

    // If this classification's input model defines attributes, return an object of those attributes with empty string values.
    const classificationAttributes = inputModels[classification]?._attributes;
    const attributesArray = Object.keys(classificationAttributes ?? {});
    if (attributesArray.length > 0) {
      return Object.fromEntries(attributesArray.map((attr) => [attr, '']));
    }

    // Return true if there are no attributes for this classification.
    return true;
  }

  async fileInputChanged(event) {
    if (!event) return;

    const fileInput = event.currentTarget;
    const files = event.dataTransfer?.files ?? fileInput?.files;
    if (!files || files.length === 0) return;

    if (files.length > 1) throw new Error('Multiple file upload is not supported.');

    const selectedItemIsNode = this.activeItem?.[0] == 'n';
    if (!selectedItemIsNode) return;

    const nodeId = this.activeItem.slice(1);

    const currentStep = this.assessmentSteps[this.pageIndex];
    const currentStepId = currentStep?._id;

    // Store the assessment step id on the photo association record on the node so we can
    // display to the user this step has been completed if we run the assessment again.
    const associatedPhotoUpdate = currentStepId != null ? { assessment: currentStepId } : null;

    const photoClassification = this.getPhotoClassificationForAssessmentStep(currentStep);
    const photoUpdate =
      currentStep.classification && photoClassification
        ? { [`photofirst_data/${currentStep.classification}/assessment`]: photoClassification }
        : null;

    const uploadOptions = {
      metadata: {
        mobileAssessmentStepId: currentStepId
      },
      association: { nodeId },
      associatedPhotoUpdate,
      photoUpdate
    };

    uploadPhoto(files[0], this.jobId, uploadOptions).catch((error) => {
      console.error('Failed to add photo to the upload queue.', error);
      showPhotoUploadErrorToast(error);
    });
    // Clear the file input.
    if (fileInput) fileInput.value = '';
  }

  // Called when primary prompt button is activated
  edit(closestItem, latitude, longitude, quickEditDetails) {
    // If we don't have a time sync (and its not disabled) show a warning
    if (!this.gotTimeSync && !this.timeSyncDisabled) {
      const html = litHtml;
      const dialog = KatapultDialog.open({
        dialog: { title: 'No Time Sync', modal: true, maxWidth: 400 },
        template: () => html`
          <div>You must take a time sync photo to use this assessment tool.</div>
          <katapult-button
            slot="buttons"
            @click="${() => {
              this.closeEditPanel();
              dialog.close();
            }}"
            >Cancel</katapult-button
          >
          <katapult-button
            slot="buttons"
            color="var(--secondary-color)"
            @click="${() => {
              this.closeEditPanel();
              this.domHost.$.timeSync.open();
              dialog.close();
            }}"
            >Close and Sync</katapult-button
          >
        `
      });

      // Do not continue with the edit
      return;
    }

    if (Array.isArray(quickEditDetails?.items)) {
      this.quickEditItems = quickEditDetails.items;
      this.quickEditCallback = quickEditDetails.callback;
      this.editing = quickEditDetails.name || 'Item';
    }

    // If this assessment has been opened on this node before
    if (this.getLastStepWithValue() >= 0) {
      let index = 0;
      // Traverse the assessment to build the currentPath array using the data on the node
      while (!this.nextButtonIsDisabled(index)) {
        index = this.getNextStepIndex(this.assessmentSteps[index].value, index);
        this.push('currentPath', index);
      }
    }

    // Get all of the time buckets from this node and save each createdBy key (or assessmentPrompt for backwards compatibility)
    const item = this.nodes?.[this.activeItem.slice(1)];
    const timeBucketsList = Object.values(item?.attributes?.time_bucket ?? {});
    this.timeBuckets = timeBucketsList.map((bucket) => bucket.createdBy ?? bucket.assessmentPrompt);

    // Reset completed drawing steps
    this.completedDrawingSteps = [];
  }

  /**
   * A property observer that is called when `pageIndex` changes
   */
  pageIndexChanged() {
    const currentStep = this.assessmentSteps[this.pageIndex];
    // Do nothing if we are not on a step
    if (!currentStep) return;

    // If we are on a step with a drawing tool that we should automatically open, call the drawing tool
    if (currentStep.drawing_tool && currentStep.auto_open_tool) this.callStepDrawingTool();
  }

  /**
   * Calls the drawing tool for the current step, unless it has already been completed
   */
  callStepDrawingTool() {
    const currentStep = this.assessmentSteps[this.pageIndex];
    const drawStepCompleted = this.completedDrawingSteps.includes(currentStep._id);
    if (drawStepCompleted) return;

    const activeItem = this.activeItem;
    const editing = this.editing;
    const button = this.activeButton;
    const assessNewNode = currentStep.assess_new_node;

    // TODO (2024-06-03): It is likely that this won't work for all drawing tools, and will need to be updated
    this.editing = '';
    this.activeTool = 'drawOnMap';
    this.activeCommand = 'select'; // <-- [TODO] Specifically this
    this.activeButton = currentStep.drawing_tool;

    this.fire('run-command', {
      callback: ({ newNodeId }) => {
        this.editing = editing;
        this.activeTool = 'assessAttributes';
        this.activeButton = button;
        this.activeItem = assessNewNode ? `n${newNodeId}` : activeItem;
        this.quickEditItems = [this.activeItem];
        this.completedDrawingSteps = [...this.completedDrawingSteps, currentStep._id];
      }
    });
  }

  toast(message, duration) {
    /** @type {HTMLElement|null} */
    const toast = this.shadowRoot?.querySelector('#editorToast') ?? null;
    if (!toast) return;

    let openDelay = 0;
    // If the toast is already open, close it
    if (toast.hasAttribute('opened')) {
      clearTimeout(this.toastTimeout);
      toast.removeAttribute('opened');
      openDelay = 200;
    }
    // Open the new toast message (after a delay, if necessary)
    setTimeout(() => {
      toast.innerText = message;
      toast.setAttribute('opened', '');
      this.toastTimeout = setTimeout(() => {
        toast.removeAttribute('opened');
      }, duration);
    }, openDelay);
  }

  completeAssessment() {
    let modelAttrs = this.mappingButtons?.[this.activeButton]?.node?.attributes;
    let item = this.nodes?.[this.activeItem.slice(1)];
    let attributes = item?.attributes || {};
    let update = {};
    for (let key in modelAttrs) {
      // If the attribute is triggered by on_finish
      if (modelAttrs[key].trigger == 'on_finish' || modelAttrs[key].type == 'stamp_on_complete') {
        // Skip this attribute if it is improperly configured
        if (!(modelAttrs[key].value && modelAttrs[key].attribute)) continue;
        // Skip this attribute if there is already a value for the given attribute and it should not be overwritten
        if (!modelAttrs[key].overwrite && !!attributes[modelAttrs[key].attribute]) continue;
        // Write the attribute to the node's attribute list
        let value = modelAttrs[key].value == '$$time' ? Date.now() : modelAttrs[key].value;
        attributes[modelAttrs[key].attribute] = { button_added: value };
        update['/nodes/' + this.activeItem.slice(1) + '/attributes/' + modelAttrs[key].attribute + '/button_added'] = value;
      }
    }
    // One last time bucket, to collect any additional photos taken before moving on
    let time = new Date().getTime();
    GeofireTools.updateStyle('nodes', this.activeItem.slice(1), item, update, this.jobStyles);
    globalThis.FirebaseWorker.ref(`photoheight/jobs/${this.jobId}`).update(update);
    this.dispatchEvent(new CustomEvent('photos-taken', { detail: { time, mode: 'external' } }));
    this.closeEditPanel();
  }

  closeEditPanel() {
    // Close the panel by removing the editing state
    this.editing = '';

    // When the panel closes, reset everything
    this.$.editPanel.addEventListener(
      'transitionend',
      () => {
        this.pageIndex = -1;
        this.hideNav = true;
        this.timeBuckets = [];
        this.stepHistory = [0];
        this.currentPath = [0];
        this.stepPhotoIds = [];
        this.completedDrawingSteps = [];
        if (this.quickEditItems.length > 0) {
          this.quickEditItems = [];
          this.quickEditCallback?.();
        }
      },
      { once: true }
    );
  }

  enterLastEnteredValueDisabled(step) {
    let attribute = step && step.attribute;
    if (this.previousValues && attribute) {
      return this.previousValues[attribute] == null;
    }
    return true;
  }

  enterLastEnteredValue(e) {
    const { attribute, itemId, itemKey: attributeKey } = e.model?.step ?? {};
    if (itemId && attribute && attributeKey && this.previousValues[attribute] != null) {
      this.commitItem(this.previousValues[attribute], attribute, attributeKey, itemId);
    }
  }

  async handleChange(event) {
    // Store required info from the event before it is lost
    const { currentTarget, detail, model: eventModel } = event;
    const { model, attribute, itemKey, calls } = eventModel.step;
    const guiElement = model?.gui_element;

    // Fix booleans
    if (detail.value == 'true') detail.value = true;
    if (detail.value == 'false') detail.value = false;

    // Get the old value
    detail.oldValue = Path.get(this.nodes, `${this.activeItem.slice(1)}.attributes.${attribute}.assessment`);
    // Commit the item change
    await this.commitItem(detail.value, attribute, itemKey, currentTarget.getAttribute('name'));

    // Update the previous value record
    this.previousValues[attribute] = detail.value;

    // If the change is on a step that is before the furthest-reached step
    if (this.stepHistory.length < this.currentPath.length && !this.scrollMode) {
      // If the change will result in a different path (different jump)
      let index = this.stepHistory.length + 1;
      if (this.getNextStepIndex(detail.value) != this.currentPath[index]) {
        // If the current page index is less than the last step that has a value
        if (this.pageIndex < this.getLastStepWithValue()) {
          let warnText = 'Making this change has changed your assessment path. Some of your data may now be invalid.';
          this.shadowRoot.querySelector('#dataVeracityWarning').openMessage('Data Veracity', warnText);
        }
        this.set('currentPath', [...this.stepHistory]);
      }
    }

    // If GUI element is a dropdown or checkbox, apply calls and advance to the next page
    if (['dropdown', 'checkbox'].includes(guiElement)) {
      this.applyCalls(calls, detail.value, detail.oldValue);
      if (!this.scrollMode && this.fastForward) setTimeout(() => this.nextPage(detail.value), this.ffDelay);
    }
  }

  calcNothingSelected(valueArray) {
    return valueArray?.length == 1 && valueArray[0]?.$val === '';
  }

  handleMultiAdd(e) {
    // Get the existing items from the model
    const values = e.model.step.value || {};
    // Filter out any blank values
    const valuesEntries = Object.entries(values);
    for (const [key, value] of valuesEntries) {
      if (value === '') delete values[key];
    }
    // Get the 'index' for the new item from the existing proper keys
    let newItemIndex = Object.keys(values).filter((item) => item.startsWith('-k')).length;
    // Add the new item to values and commit the change
    values[`-k${newItemIndex.toString(10).padStart(3, '0')}`] = e.model.item.value;
    // Save the change
    this.commitItem(values, e.model.step.property, '', e.model.step.itemId);
  }

  // TODO: Deleting quickly causes data problems
  handleMultiRemove(e) {
    // Get the existing items from the model
    const values = e.model.step.value;
    // Get the index of the item to remove
    const removeKey = e.model.item.$key;
    // For each key in values, copy to the new values object, leaving out the removed item
    const newValues = {};
    let counter = 0;
    for (const key in values) {
      if (key != removeKey && values[key] != null) {
        newValues[`-k${counter.toString(10).padStart(3, '0')}`] = values[key];
        counter += 1;
      }
    }
    // Finally, set the last key to null and commit the change with the new values object
    newValues[`-k${counter.toString(10).padStart(3, '0')}`] = null;
    // If there is only one key and it's null, reset it back to an empty string
    if (Object.keys(newValues).length == 1 && Object.values(newValues)[0] === null)
      newValues[`-k${counter.toString(10).padStart(3, '0')}`] = '';
    // Save the change
    this.commitItem(newValues, e.model.step.property, '', e.model.step.itemId);
  }

  multiSelectOrderChanged(e) {
    // If the change matters
    if (e.detail.prevIndex != e.detail.index) {
      // Get the value array from the model
      let valueArray = e.model.step.valueArray;
      // Splice the array to move the item
      let movedItem = valueArray.splice(e.detail.prevIndex, 1)[0];
      valueArray.splice(e.detail.index, 0, movedItem);
      // Create a new values object with the correct keys from the spliced array and commit the change
      let values = {};
      for (const key in valueArray) values[`-k${key.toString(10).padStart(3, '0')}`] = valueArray[key].$val;
      this.commitItem(values, e.model.step.property, '', e.model.step.itemId);
    }
  }

  applyCalls(calls, trigger, undoTrigger) {
    // If calls does not exist, return immediately
    if (!calls) return;

    // This function takes a calls object and a trigger (a selected pick item or $advance) and applies calls based on the trigger
    const nodeId = this.activeItem.slice(1);
    const node = this.nodes?.[nodeId] || {};
    const attributes = node.attributes || {};
    let update = {};

    // If there is an undo trigger
    if (undoTrigger) {
      // Get the calls we should undo based on our undo trigger
      const callsToUndo = Object.values(calls).filter((call) => (call.trigger || call.pick_item).toString() == undoTrigger.toString());
      // For each call we want to undo, set the attribute to null in the update object and the node's attributes object
      for (const call of callsToUndo) {
        update[`nodes/${nodeId}/attributes/${call.attribute}/${this.activeItem}`] = null;
        attributes[call.attribute] = { [this.activeItem]: null };
      }
    }

    // Get the calls we should apply for the given trigger (using trigger if it is defined, and pick item otherwise)
    const callsToApply = Object.values(calls).filter((call) => (call.trigger || call.pick_item).toString() == trigger.toString());
    // For each call we want to apply, set the change on the update object and the node's attributes object
    for (const call of callsToApply) {
      // handle edge case for multi dropdowns
      if (this.otherAttributes?.[call.attribute]?.gui_element == 'multi_dropdown') {
        update[`nodes/${nodeId}/attributes/${call.attribute}`] = call.value;
        attributes[call.attribute] = call.value;
      } else {
        update[`nodes/${nodeId}/attributes/${call.attribute}/${this.activeItem}`] = call.value;
        attributes[call.attribute] = { [this.activeItem]: call.value };
      }
    }

    // Update map styles and update the Firebase record
    GeofireTools.updateStyle('nodes', nodeId, node, update, this.jobStyles);
    if (Object.keys(update).length > 0) globalThis.FirebaseWorker.ref(`photoheight/jobs/${this.jobId}`).update(update);
  }

  photosTakenExternal(e) {
    // Get the current time
    let time = new Date().getTime();
    // Get the current step
    let currentStep = e.model.step || e.model.parentModel.step;
    let createdBy, classification;
    // If the step type is photo
    if (currentStep.type == 'photo') {
      createdBy = currentStep.uid || currentStep.title;
      classification = currentStep.classification;
      // Fall back to chip attributes if there is no classification
      if (!classification && currentStep.chip_attributes) classification = Object.keys(currentStep.chip_attributes)[0];
    }
    // If the step type is photo_group
    else if (currentStep.type == 'photo_group') {
      let prompt = currentStep.photo_prompts[e.model.index];
      createdBy = prompt.uid || prompt.title;
      classification = prompt.classification;
      // Fall back to chip attributes if there is no classification
      if (!classification && prompt.chip_attributes) classification = Object.keys(prompt.chip_attributes)[0];
    }
    // add any attribute for classification based on the input model type
    let classificationInputModel = this.inputModels?.[classification];
    if (classificationInputModel) {
      let classificationAttributes = true;
      // compute the attributes if the classification is an input model and it has attributes
      if (classificationInputModel?._attributes !== true) {
        classificationAttributes = {};
        for (let key in classificationInputModel._attributes || {}) {
          if (classificationInputModel._attributes[key]?.value == null) classificationAttributes[key] = '';
          else classificationAttributes[key] = classificationInputModel._attributes[key].value;
        }
      }
      // add the attributes to the classification
      classification = { [classification]: classificationAttributes };
    }
    // Dispatch an event to katapult-maps to trigger the time bucket close
    this.dispatchEvent(
      new CustomEvent('photos-taken', { detail: { time, classification, createdBy, mode: 'external', noAutoZoom: true } })
    );
    this.push('timeBuckets', createdBy);
    // If fast-forwarding, go to next page
    if (!this.scrollMode && this.fastForward && currentStep.type != 'photo_group') setTimeout(() => this.nextPage(), this.ffDelay);
  }

  computeAttributeValues(otherAttributes, attributeName, picklistName, stepValues, oldMultiSelect, oldDuplicates) {
    // Default to an empty array if attribute definitions are missing
    if (!otherAttributes) return [];

    const model = otherAttributes[attributeName] || {};
    // If picklistName is null, grab the first picklist (usually default or original)
    const picklist = model?.picklists?.[picklistName] ?? Object.values(model.picklists ?? {})[0];

    const isMultiDropdownWithoutDuplicates = model.gui_element == 'multi_dropdown' && !model.allow_duplicates;
    const isLegacyMultiDropdownWithoutDuplicates = model.gui_element == 'dropdown' && oldMultiSelect && !oldDuplicates;
    // Filter out already selected options for multi dropdowns that disallow duplicates
    if (stepValues && (isMultiDropdownWithoutDuplicates || isLegacyMultiDropdownWithoutDuplicates)) {
      return picklist.filter((item) => !stepValues.find((x) => x.$val == item.value));
    }

    return picklist;
  }

  computeShowEditButtonsInMenu(usingMobileAssessmentsWorkflow, deleteAndMoveEnabled) {
    return !usingMobileAssessmentsWorkflow || deleteAndMoveEnabled == true;
  }

  showGuiElement(step, elementType, scrollMode) {
    // If the step is not defined, return false
    if (!step) return false;

    // Get the step's type (if it is an attribute type, get the gui_element)
    let type = step.model?.gui_element || step.type;
    // Handle legacy step types
    if (type == 'gps_set_location') type = 'set_location';
    if (step.multi_select && type == 'dropdown') type = 'multi_dropdown';

    // Determine if the step should use the custom dropdown UI
    const noCustomDropdownUI = step.display_dropdown_as_dropdown === true;
    const useCustomDropdownUI = !noCustomDropdownUI && !scrollMode;

    // Create an array with the allowable step types
    const stepTypesWithSpecialUI = [
      'checkbox',
      'set_location',
      'set_address_data',
      'photo',
      'photo_group',
      'drawing_tool',
      // Add the dropdown types if we are not in scroll mode
      ...(useCustomDropdownUI ? ['dropdown', 'multi_dropdown'] : [])
    ];

    // Determine if the provided element type should be shown for this step
    const isSpecialUITypeAndMatchesElementType = stepTypesWithSpecialUI.includes(type) && type == elementType;
    const isInputTypeAndNotListed = !stepTypesWithSpecialUI.includes(type) && elementType == '$input';
    return isSpecialUITypeAndMatchesElementType || isInputTypeAndNotListed;
  }

  makeBoolString(value) {
    if (typeof value == 'boolean') return value.toString();
    if (typeof value == 'string') return value;
    return null;
  }

  formatSeconds(seconds) {
    seconds = parseInt(seconds);
    let formattedSeconds = '';
    let hours = Math.floor(seconds / 3600);
    if (hours > 0) {
      formattedSeconds = hours + ':';
      seconds = seconds - hours * 3600;
    }
    let mins = Math.floor(seconds / 60);
    formattedSeconds += mins.toString().padStart(2, '0') + ':';
    seconds = seconds - mins * 60;
    formattedSeconds += seconds.toString().padStart(2, '0');
    return formattedSeconds;
  }

  formatCoordinates(lat, lng) {
    return lat && lng ? `(${lat.toFixed(8)}, ${lng.toFixed(8)})` : `(--.--, --.--)`;
  }

  async getImageSource() {
    const image = this.assessmentSteps?.[this.pageIndex]?.image;
    if (image?.path) {
      const imgRef = globalThis.firebase.storage().ref(image.path);
      this.imageSource = await imgRef.getDownloadURL();
    }
  }

  openImageViewer() {
    this.shadowRoot?.querySelector('#imageViewer')?.open();
    this.shadowRoot?.querySelector('#imageViewerPhoto')?.srcChanged(this.imageSource);
  }

  getScrollMode(config) {
    if (config) this.scrollMode = true;
  }

  // TODO (03-01-2022): Potentially unused?
  map_pan(latitude, longitude, closest) {
    if (closest == null) {
      this.activeItem = '';
      this.closeEditPanel();
    } else {
      this.activeItem = closest.item;
    }
  }

  canUploadPhoto() {
    return this.activeItem && (this.activeItem[0] == 'n' || this.activeItem[0] == 's');
  }

  setAddressData(e) {
    // Get the address attributes to fetch from the assessment's model
    let addressAttributes = e?.model?.step?.address_attributes || {};
    let stateAbbreviation = e?.model?.step?.state_abbreviation;

    // Set the flag that the user hit the address data button
    let stepId = e?.model?.step?._id;
    if (stepId) {
      this.set(`tappedSetAddressButton.${stepId}`, true);
    }

    let options = {
      addressAttributes,
      stateAbbreviation,
      modelDefaults: this.modelDefaults
    };

    let coordinateList = [];
    let nodeId = this.activeItem.slice(1);
    let node = this.nodes?.[nodeId];
    if (node) {
      coordinateList.push({
        key: nodeId,
        attributes: node.attributes,
        lat: Number(node.latitude),
        long: Number(node.longitude),
        [this.modelDefaults.ordering_attribute]: PickAnAttribute(node.attributes, this.modelDefaults.ordering_attribute) || '???'
      });

      this.shadowRoot.querySelector('#setAddressDataSpinner').active = true;

      let jobRef = FirebaseWorker.ref(`photoheight/jobs/${this.jobId}`);
      getAddressData(coordinateList, 0, coordinateList.length, 5, jobRef, options, null, () => {
        setTimeout(() => {
          this.shadowRoot.querySelector('#setAddressDataSpinner').active = false;
          let geoUpdate = {};
          GeofireTools.updateStyle('nodes', nodeId, this.nodes?.[nodeId], geoUpdate, this.jobStyles);
          FirebaseWorker.ref(`photoheight/jobs/${this.jobId}`).update(geoUpdate);
        }, 1);
      });
    }
  }

  getAddressButtonIcon(step) {
    let addressAttributes = step?.address_attributes || {};
    for (let addressComponent in addressAttributes) {
      let attribute = addressAttributes[addressComponent];
      if (!PickAnAttribute(this.nodes?.[this.activeItem.slice(1)]?.attributes, attribute)) {
        return '';
      }
    }
    return 'done';
  }

  setLocationOnMap(e) {
    const editing = this.editing;
    this.editing = '';
    this.activeTool = 'moveItem';
    this.activeCommand = 'select';

    this.fire('run-command', {
      callback: (results) => {
        // Return control to "assess attributes"
        this.editing = editing;
        this.activeTool = 'assessAttributes';

        const { _id: stepId, gps_verification_attribute: gpsVerificationAttribute } = e?.model?.step ?? {};
        // Set if the step was done with GPS
        if (stepId) this.set(`locationsSetWithGPS.${stepId}`, results.positionIsBasedOnGPS || false);

        // Set the GPS verification attribute if it exists
        // TODO (2024-11-14): 'mobile' as update method?
        if (gpsVerificationAttribute) this.commitItem(true, gpsVerificationAttribute, 'button_added', this.activeItem);
      }
    });
  }

  updateNodeOrderAttribute() {
    let orderValue = null;
    if (this.editing === 'Node' && this.activeItem) {
      orderValue = PickAnAttribute(this.nodes?.[this.activeItem.slice(1)]?.attributes, this.modelDefaults.ordering_attribute) || null;
    }
    this.orderValue = orderValue;
  }

  updateTitle() {
    if (this.editing === 'Node' && this.orderValue)
      this.title = `${CamelCase(this.modelDefaults.ordering_attribute)} ${this.orderValue} Assessment`;
    else if (this.activeButton) this.title = CamelCase(this.activeButton).toUpperCase();
    else this.title = `${this.editing} Assessment`;
  }

  showItemCoordinates(activeItem) {
    var isNode = activeItem[0] == 'n';
    if (isNode) this.showNodeLocationUpdate = false;
    return isNode;
  }

  getAssessmentSteps(activeItem, quickEditItems, otherAttributes, mappingButtons) {
    const typePrefixedItem = Array.isArray(quickEditItems) ? quickEditItems[0] : activeItem;
    if (typePrefixedItem?.[0] != 'n' && typePrefixedItem?.[0] != 's') return [];

    let assessingItem = {};
    if (typePrefixedItem[0] == 'n') {
      const nodeId = typePrefixedItem.slice(1);
      assessingItem = this.nodes?.[nodeId];
    } else {
      const sectionConnectionId = this.activeItem.slice(1);
      const sectionId = sectionConnectionId.split(':')[1];
      const connId = sectionConnectionId.split(':')[0];
      assessingItem = this.connections?.[connId]?.sections?.[sectionId];
    }

    if (!assessingItem) return [];

    const assessmentSteps = [];
    const button = this.activeButton || assessingItem.button;
    const attributes = assessingItem.attributes || assessingItem.multi_attributes;
    const modelAttributes = mappingButtons?.[button]?.node?.attributes;

    // For each step in the model
    for (const stepId in modelAttributes) {
      // Ignore assessment actions
      if (!modelAttributes[stepId].order) continue;

      const attributeId = modelAttributes[stepId].attribute;
      const step = {
        ...modelAttributes[stepId],
        // TODO: These may need refactoring
        _id: stepId.replace(/\W/g, ''),
        itemId: typePrefixedItem,
        property: attributeId || null,
        itemKey: 'assessment',
        model: attributeId ? otherAttributes[attributeId] : null
      };

      // If the step is an attribute step
      if (step.type == 'attribute') {
        // Check if the nodes array contains the attribute, and if it does, see if it has a value and set it on the step
        const existingValues = attributes?.[step.attribute];

        if (step?.model?.gui_element == 'table') {
          const pushId = globalThis.FirebaseWorker.database().ref().push().key;
          step.value = existingValues || { [pushId]: GetNewAttributeValue(step.attribute, otherAttributes) };
          step.itemKey = 'table';
        }
        // If the step is a multi dropdown
        else if (step?.model?.gui_element == 'multi_dropdown' || step.multi_select) {
          // clear out any null values
          for (const key in existingValues) if (existingValues[key] == null) delete existingValues[key];
          step.value = existingValues;
          // Create a special property to store and display the data as an array
          if (existingValues) step.valueArray = Object.entries(existingValues ?? {}).map(([$key, $val]) => ({ $key, $val }));

          // If any key in nodeAttribute does not follow the convention, fix all of the keys
          if (Object.keys(existingValues ?? {}).filter((item) => !item.startsWith('-k')).length > 0) {
            let newObject = {};
            let counter = 0;
            for (const key in existingValues) {
              let newValue = existingValues[key];

              // Remove any $key property or sub properties; trying to write a Firebase path with a "$" in it will cause an error which
              // prevents all mobile data from being written because the code thinks the device is offline
              delete newValue.$key;
              for (const property in newValue) if (property == '$key') delete newValue[property];

              newObject[`-k${counter.toString(10).padStart(3, '0')}`] = newValue;
              counter += 1;
            }
            this.commitItem(newObject, step.property, '', step.itemId);
          }
        }
        // Otherwise, set the value (or default value for new nodes)
        else {
          // Get the first existing values for the attribute
          const items = Object.entries(existingValues ?? {});
          // If there is only one item, set the step's value to that
          if (items.length == 1) {
            const [key, value] = items[0];
            step.value = value;
            step.itemKey = key;
          }
          // Otherwise, there is no value. Set the default value to be used in the assessment
          else {
            step.value = GetNewAttributeValue(step.attribute, otherAttributes);
            if (step?.model?.gui_element == 'checkbox') step.value = null;
          }
        }
      }

      // Another band-aid for my egregious spelling error
      if (step.exteral_photo_allowed) step.external_photo_allowed = true;

      // Push to the array
      assessmentSteps.push(step);
    }

    assessmentSteps.sort(this.sortAttributesByOrder);

    // Calculate the items to be hidden for scroll mode
    if (this.scrollMode) {
      let jumpTo = null;
      let incompleteJump = false;
      // For each step in the assessment
      assessmentSteps.forEach((step) => {
        // If we are jumping
        if (jumpTo != null) {
          // If the jump stops here
          if ([step.uid, step._id].includes(jumpTo)) jumpTo = null;
          // Otherwise, hide the step by default
          else {
            step.hidden = true;
            if (incompleteJump) {
              step.incompleteJump = true;
              incompleteJump = false;
            }
          }
        }
        // If we are done jumping and the current step has a jump
        if (jumpTo == null && step.jump_to) {
          // If the jump is an unconditional jump
          if (typeof step.jump_to === 'string') jumpTo = step.jump_to;
          // Otherwise, the jump has conditions
          else {
            // If the step is incomplete
            let stepIncomplete = step.value === undefined || step.value === '';
            let lastIndex = -1;
            // For each jump definition in this step's jump
            for (const key in step.jump_to) {
              let jump = step.jump_to[key];
              // If the step is incomplete
              if (stepIncomplete) {
                // If the destination of the jump is the end of the assessment
                if (jump.destination == '$end') {
                  jumpTo = jump.destination;
                  incompleteJump = true;
                }
                // Otherwise, the destination is another step
                else {
                  // Set the lastIndex to the destination (provided the jump is forward, not backward)
                  let jumpIndex = assessmentSteps.findIndex((item) => [item.uid, item._id].includes(jump.destination));
                  if (jumpIndex > lastIndex) lastIndex = jumpIndex;
                }
              }
              // Otherwise, the step is complete; if the step value is equal to the jump value, jump to the next step
              else if (step.value == jump.value) jumpTo = jump.destination;
            }
            // If the last index changed, note the new jumpTo step and mark the jump incomplete
            if (lastIndex != -1) {
              jumpTo = assessmentSteps[lastIndex].uid || assessmentSteps[lastIndex]._id;
              incompleteJump = true;
            }
          }
        }
      });
    }

    // Set requiredItemsComplete if all visible required steps are completed
    this.set(
      `requiredItemsComplete`,
      assessmentSteps.every((step) => step.hidden || this.stepCompleted(step))
    );

    return assessmentSteps;
  }

  sortAttributesByPriority(a, b) {
    let aPriority = a.model?.priority ?? Infinity;
    let bPriority = b.model?.priority ?? Infinity;
    // Sort by itemKey (firebase key) if priority is equal.
    if (aPriority == bPriority) {
      if (a.itemKey > b.itemKey) return 1;
      if (a.itemKey < b.itemKey) return -1;
    }
    return aPriority - bPriority;
  }

  sortAttributesByOrder(a, b) {
    let aOrder = a.order ?? Infinity;
    let bOrder = b.order ?? Infinity;
    // Sort by itemKey (firebase key) if priority is equal.
    if (aOrder == bOrder) {
      if (a.itemKey > b.itemKey) return 1;
      if (a.itemKey < b.itemKey) return -1;
    }
    return aOrder - bOrder;
  }

  /**
   * Set the attribute value for the given item.
   * @param {Object} value - The value to set.
   * @param {string} attribute - The attribute to set.
   * @param {string} itemKey - The key of the item to set.
   * @param {string} itemId - The ID of the item to set.
   */
  async commitItem(value, attribute, itemKey, itemId) {
    // Make sure the item is a node
    if (itemId[0] != 'n' && itemId[0] != 's')
      throw new Error('Attempted to commit data with an assessment for an item that is not a node or a section');

    // Get the job API
    const job = KatapultJob.fromId(this.jobId);

    // Handle special case with tables and multi-dropdowns
    const attributeIsTableOrMultiDropdown = ['table', 'multi_dropdown'].includes(this.otherAttributes?.[attribute]?.gui_element);
    if (attributeIsTableOrMultiDropdown) itemKey = '';

    if (itemId[0] == 'n') {
      // Get the current item node ID
      const nodeId = itemId.slice(1);

      // Handle special case with tables
      if (attributeIsTableOrMultiDropdown) await job.updateNodeAttribute(nodeId, attribute, value, { replaceExisting: true });
      // All other attribute types
      else await job.updateNodeAttribute(nodeId, attribute, { [itemKey]: value });
    } else {
      // Get the current item section and connection IDs
      const sectionConnectionId = this.activeItem.slice(1);
      const sectionId = sectionConnectionId.split(':')[1];
      const connId = sectionConnectionId.split(':')[0];

      // Handle special case with tables
      if (attributeIsTableOrMultiDropdown) await job.updateSectionAttribute(connId, sectionId, attribute, value, { replaceExisting: true });
      // All other attribute types
      else await job.updateSectionAttribute(connId, sectionId, attribute, { [itemKey]: value });
    }
  }

  deleteItem(e) {
    let body = '';
    let update = {};
    let itemList = this.quickEditItems;
    if (itemList.length == 0) {
      itemList = [this.activeItem];
    }
    for (let i = 0; i < itemList.length; i++) {
      if (itemList[i].slice(1) != '') {
        let id = itemList[i].slice(1);
        if (itemList[i][0] == 'n') {
          update['nodes/' + id] = null;
          update['geohash/' + id] = null;
          update['app_geohash/' + id] = null;
          let connLookup = loadRenderMap.pointLocations[itemList[i].slice(1)]?.data?.n;
          let deletedConnections = 0;
          for (const connId in connLookup) {
            this.deleteConnection(connId, update, id);
            deletedConnections++;
          }
          if (this.quickEditItems.length == 0 && deletedConnections > 0) {
            body = '(' + deletedConnections + ') connections will be deleted.';
          }
        } else if (itemList[i][0] == 's') {
          var ids = itemList[i].slice(1).split(':');
          if (ids[0] != '' && ids[1] != '') {
            update['connections/' + ids[0] + '/sections/' + ids[1]] = null;
            update['geohash/' + ids[0] + ':' + ids[1]] = null;
          }
        } else {
          this.deleteConnection(id, update);
        }
      }
    }
    this.dispatchEvent(
      new CustomEvent('confirm', {
        detail: {
          heading: 'Delete this ' + this.editing + '?',
          body: body,
          affirmativeText: 'Delete',
          dismissiveText: 'Cancel',
          affirmativeStyle: 'background-color:#d23f31; color:white;',
          callback: function (update) {
            this.editing = '';
            this.activeItem = '';
            if (this.quickEditItems.length > 0) {
              this.quickEditItems = [];
              this.quickEditCallback?.(true);
            }
            FirebaseWorker.ref(`photoheight/jobs/${this.jobId}`).update(
              update,
              function (error) {
                if (error) {
                  this.dispatchEvent(new CustomEvent('toast', { detail: error }));
                }
              }.bind(this)
            );
          }.bind(this, update)
        }
      })
    );
  }

  deleteConnection(connId, update, nodeDeleting) {
    update['connections/' + connId] = null;
    update['geohash/' + connId + '~1'] = null;
    update['geohash/' + connId + '~2'] = null;

    let conn = this.connections[connId];
    if (conn.node_id_1 != nodeDeleting) {
      update['geohash/' + conn.node_id_1 + '/n/' + connId] = null;
    }
    if (conn.node_id_2 != nodeDeleting) {
      update['geohash/' + conn.node_id_2 + '/n/' + connId] = null;
    }
    for (var sectionId in conn.sections) {
      update['geohash/' + connId + ':' + sectionId] = null;
    }
  }

  getByKey(type, id, attribute) {
    return this.domHost.getByKey(type, id, attribute);
  }

  getLastStepWithValue() {
    let length = this.assessmentSteps.length || 0;
    for (let i = length - 1; i >= 0; i -= 1) {
      const step = this.assessmentSteps[i];
      // Check for complex values with table or multi drop down attributes
      if (step?.model?.gui_element == 'table' || step?.model?.gui_element == 'multi_dropdown') {
        const flattenedData = Path.flattenObject(step.value ?? {});
        if (Object.values(flattenedData).some((val) => val)) {
          return i;
        }
        continue;
      }
      if (step.value) return i;
    }
    return -1;
  }

  getNavSteps() {
    let navSteps = [];
    for (const key in this.currentPath) {
      navSteps.push(this.assessmentSteps[this.currentPath[key]] || { _id: '$end', title: 'End' });
    }
    return navSteps;
  }

  hidePage(index, num, hideNav, scrollMode) {
    if ((index == num || scrollMode) && hideNav) return false;
    return true;
  }

  backButtonIsDisabled(index) {
    return index <= 0;
  }

  nextButtonIsDisabled(index) {
    const maxIndex = this.assessmentSteps.length;
    const currentStep = this.assessmentSteps[index];
    // If at end of pages, disable next
    if (index >= maxIndex) return true;
    // If in special assessment and attribute is required and has no value, disable next
    if (this.activeButton && currentStep) return !this.stepCompleted(currentStep);
    // Otherwise, enable next button
    return false;
  }

  activeItemChanged(activeItem) {
    this.locationsSetWithGPS = {};
    this.tappedSetAddressButton = {};
  }

  updatePhotoUploadEventListener() {
    this._disconnectPhotoUploadListener?.();

    // Only listen for photo upload events for nodes.
    if (!this.activeItem || this.activeItem[0] !== 'n') return;

    const disconnect = listenToUploadEventsForNode(this.jobId, this.activeItem.slice(1), this.photoUploadEventHandler.bind(this));
    this._disconnectPhotoUploadListener = () => {
      disconnect();
      this.photoUploadEventHandler(null);
    };
  }

  photoUploadEventHandler(progress) {
    this._photoUploadProgress = progress;
  }

  stepCompleted(step) {
    // If the current step is a (single) photo prompt and has a time bucket, it is complete
    const attributeModel = this.otherAttributes?.[step.attribute];
    if (step.type == 'photo' && this.hasTimeBucket(step)) return true;
    else if (step.type == 'photo' && this.tookPhotosWithDevice(this.nodes, this.activeItem, step)) return true;
    // If the current step is a multi-photo prompt, ensure each require photo has a time bucket
    else if (step.type == 'photo_group') {
      for (const key in step.photo_prompts)
        if (step.photo_prompts[key].required && !this.hasTimeBucket(step.photo_prompts[key])) return false;
    } else if (step.type == 'set_location') {
      // Check if using the GPS is required
      if (step.require_gps && step._id) {
        if (!this.locationsSetWithGPS[step._id]) return false;
      }
      // Check if the step needs to have a verification attribute
      if (step.required && step.gps_verification_attribute) {
        return this.nodes?.[this.activeItem.slice(1)]?.attributes?.[step.gps_verification_attribute] != null;
      }
    } else if (step.type == 'set_address_data') {
      // Check that the user has attempted to fetch address data - we can't guarantee that they were able to fetch address data because of bad service
      return this.tappedSetAddressButton[step._id] || this.getAddressButtonIcon(step) == 'done';
    } else if (step.type == 'drawing_tool') {
      return !step.required || this.completedDrawingSteps.includes(step._id);
    }
    // If the current page has a required input that is blank, it's not complete
    else if (step.required && (step.value === undefined || step.value === '')) return false;
    // If the current step has a required input that is blank, it's not complete
    else if (step.required && [null, undefined, ''].includes(step.value)) return false;
    // if we have special validation, use it
    else if (attributeModel?.validation) {
      const isValid = validateValue(step.value, attributeModel, { isMobileAssessmentInput: true });
      return isValid !== false;
    }
    // Otherwise, it's complete
    return true;
  }

  prevPage() {
    // Pop the current index from stepHistory, and get the previous step index, handling jumps
    this.pop('stepHistory');
    let newIndex = this.stepHistory[this.stepHistory.length - 1];

    this.set('pageIndex', newIndex);
  }

  nextPage(eventOrSelectedValue) {
    const selectedValue = !(eventOrSelectedValue instanceof Event) ? eventOrSelectedValue : null;
    const valueForStep = selectedValue ?? this.assessmentSteps[this.pageIndex].value;

    // Get next step index, handling jumps, and push it onto stepHistory
    const newIndex = this.getNextStepIndex(valueForStep);
    this.push('stepHistory', newIndex);

    // Add this step index to currentPath (if it doesn't already have it)
    if (!this.currentPath.includes(newIndex)) this.push('currentPath', newIndex);
    // Apply any calls from the advancing of this step (before going to the next page)
    this.applyCalls(this.assessmentSteps[this.pageIndex].calls, '$advance');

    this.pageIndex = newIndex;
  }

  getNextStepIndex(itemValue, currentIndex) {
    const index = currentIndex != null && currentIndex >= 0 ? currentIndex : this.pageIndex;
    const jumpList = this.assessmentSteps[index].jump_to;

    // Checks to see if there should be a jump to another attribute based on the answer
    if (this.activeButton && jumpList) {
      const isUnconditionalJump = typeof jumpList == 'string';
      const jumpTarget = isUnconditionalJump ? jumpList : Object.values(jumpList)?.find((jump) => jump.value == itemValue)?.destination;

      // If the jump target is the end of the assessment, go the the "end" (one past the last step)
      if (jumpTarget == '$end') return this.assessmentSteps.length;
      // If the jump target is another step, find the index of that step by its uid (or legacy _id)
      const remainingSteps = this.assessmentSteps.slice(index + 1);
      let jumpTargetIndex = remainingSteps.findIndex((step) => step.uid == jumpTarget || step._id == jumpTarget);
      if (jumpTargetIndex == -1) return index + 1;
      return jumpTargetIndex + index + 1;
    }

    return index + 1;
  }

  attributePanelRenderedItemCountChanged() {
    // If the assessment is not yet loaded or has 0 steps, don't do anything
    if (!this.assessmentSteps.length) return;

    this.registerAnimations();
    this._updateShadow();
  }

  registerAnimations() {
    // If the assessment is not yet loaded or has 0 steps, don't do anything
    if (!this.assessmentSteps.length) return;
    // Register animations for each step, the navigation slide, and the ending slide
    this.assessmentSteps.forEach((step) => {
      this.anim.register(this.shadowRoot.querySelector(`#step_${step._id}`), {
        observer: 'scrollMode, pageIndex, hideNav',
        rules: [
          {
            if: (scrollMode, pageIndex, hideNav) => scrollMode == false && pageIndex > step.order - 1 && hideNav == true,
            style: { $invisible: true, transform: 'translateX(-200px)' }
          },
          {
            if: (scrollMode, pageIndex, hideNav) => scrollMode == false && (pageIndex < step.order - 1 || hideNav == false),
            style: { $invisible: true, transform: 'translateX(200px)' }
          },
          {
            if: (scrollMode, pageIndex, hideNav) => scrollMode == false && pageIndex == step.order - 1 && hideNav == true,
            style: { $invisible: false, transform: 'none' }
          },
          {
            if: (scrollMode, pageIndex, hideNav) => scrollMode == true,
            style: { $invisible: false, transform: 'none' }
          }
        ]
      });
    });

    this.anim.register(this.shadowRoot.querySelector(`#assessmentNavigation`), {
      observer: 'hideNav',
      rules: [
        {
          if: (hideNav) => hideNav == true,
          style: { $invisible: true, transform: 'translateY(-200px)' }
        },
        {
          if: (hideNav) => hideNav == false,
          style: { $invisible: false, transform: 'none' }
        }
      ]
    });

    this.anim.register(this.shadowRoot.querySelector(`#assessmentCompleted`), {
      observer: 'pageIndex, assessmentSteps, scrollMode, hideNav',
      rules: [
        {
          if: (pageIndex, assessmentSteps, scrollMode, hideNav) =>
            !assessmentSteps || pageIndex < assessmentSteps.length || scrollMode == true || hideNav == false,
          style: { $invisible: true, transform: 'translateX(200px)' }
        },
        {
          if: (pageIndex, assessmentSteps, scrollMode, hideNav) =>
            assessmentSteps && pageIndex >= assessmentSteps.length && scrollMode == false && hideNav == true,
          style: { $invisible: false, transform: 'none' }
        }
      ]
    });

    this.anim.register(this.shadowRoot.querySelector(`#navigationButtons`), {
      observer: 'hideNav, scrollMode',
      rules: [
        {
          if: (hideNav, scrollMode) => hideNav == true && scrollMode == false,
          style: { $invisible: false, transform: 'none' }
        },
        {
          if: (hideNav, scrollMode) => hideNav == false || scrollMode == true,
          style: { $invisible: true, transform: 'translateY(50px)' }
        }
      ]
    });

    this.anim.register(this.shadowRoot.querySelector(`#scrollModeCompleteButton`), {
      observer: 'scrollMode, requiredItemsComplete',
      rules: [
        {
          if: (scrollMode, requiredItemsComplete) => scrollMode == true && requiredItemsComplete == true,
          style: { $invisible: false, transform: 'none' }
        },
        {
          if: (scrollMode, requiredItemsComplete) => scrollMode == false || requiredItemsComplete == false,
          style: { $invisible: true, transform: 'translateY(50px)' }
        }
      ]
    });

    this.anim.register(this.shadowRoot.querySelector(`#assessmentEditor`), {
      observer: `scrollMode, requiredItemsComplete`,
      rules: [
        {
          if: (scrollMode, requiredItemsComplete) => (scrollMode == true && requiredItemsComplete == true) || scrollMode == false,
          style: { marginBottom: '80px' }
        },
        {
          if: (scrollMode, requiredItemsComplete) => scrollMode == true && requiredItemsComplete == false,
          style: { marginBottom: '0' }
        }
      ]
    });
  }

  scrollModeChanged() {
    this.set(`modeTransitioning`, true);
    setTimeout(() => this.set(`modeTransitioning`, false), 300);
    // If the menu is displayed, hide it for now
    if (!this.hideNav) this.set(`hideNav`, true);
  }

  calcTableStyle(allowScroll, tableWidth) {
    // If allow scroll is true, the table attribute will extend offscreen and scroll horizontally
    // Otherwise, it will be squished to fit the panel
    if (allowScroll) {
      // In the mobile assessment panel, the max table attribute width should be 1000px and the min should be 400px
      // rather than 3000px and 400px. This complicated equation scales the tableWidth value accordingly
      const mobileWidthDivider = ((tableWidth - 400) / 2600) * 2 + 1;
      const mobileWidth = Math.round(tableWidth / mobileWidthDivider);
      return `width: ${mobileWidth}px`;
    } else return 'width: 100%';
  }

  getPageNumber(index) {
    return index + 1;
  }

  hasTimeBucket(item) {
    // Look through the time buckets array for an instance of the item's id (or title for backwards compatibility)
    return this.timeBuckets.findIndex((b) => b == (item.uid || item.title)) >= 0;
  }

  tookPhotosWithDevice(nodes, activeItem, step) {
    let activeItemKey = this.activeItem.slice(1);
    let photos = this.nodes?.[activeItemKey]?.photos;
    if (photos) {
      for (let photoKey in photos) {
        if (photos[photoKey].assessment == step._id) return true;
      }
    }
    const photoForStepBeingUploaded = Object.values(this._photoUploadProgress?.uploadProgressByRecord ?? {}).some(
      (record) => record.metadata?.mobileAssessmentStepId === step._id
    );
    if (photoForStepBeingUploaded) return true;
    return false;
  }

  async getPhotosForStep() {
    // get the step for the current page index
    let step = this.assessmentSteps?.[this.pageIndex];
    if (!step) return;
    // get the photos for the current node
    let activeItemKey = this.activeItem.slice(1);
    let photos = this.nodes?.[activeItemKey]?.photos || {};
    let photoKeys = Object.keys(photos);
    // filter the photos by their classification
    let classification = step.classification;
    // if there is no classification, don't show any photos
    let classificationPhotos = [];
    if (classification) {
      // only include photos with the same classification as the step
      classificationPhotos = photoKeys.filter((photoKey) => {
        // get the photo data
        let photoData = this.jobPhotos[photoKey]?.photofirst_data;
        if (!photoData) return false;
        // add the photo to the classification photos if it matches the classification
        if (Object.keys(photoData).includes(classification)) return true;
      });
    }
    // import the photo viewer if we haven't already and we have photos to load
    if (classificationPhotos.length > 0) await import('../katapult-photo/katapult-photo-viewer.js');
    // set the step photo ids to be the classification photos
    this.stepPhotoIds = classificationPhotos;
  }

  openFullscreenPhoto(e) {
    this.dispatchEvent(new CustomEvent('open-photo', { detail: e }));
  }

  toggleHideNav() {
    this.hideNav = !this.hideNav;
  }

  toggleSelfActive(e) {
    // Get a reference to the button
    const button = e.currentTarget;
    // Get the property that this button should toggle
    const prop = button.getAttribute('toggle-property');
    // Toggle the property
    this[prop] = !this[prop];
    // Toggle the background of certain buttons
    if (['scrollMode', 'fastForward'].includes(prop)) button.color = this[prop] ? 'var(--secondary-color)' : '#ddd';
    // Flip the icon of certain buttons
    else if (['stepToolsOpened'].includes(prop)) button.icon = this[prop] ? 'expand_less' : 'expand_more';
  }

  jumpTo(e) {
    let jumpTarget = e.currentTarget.step_id;
    let found = false;
    // If the name of the target step is $end, then show the end
    if (jumpTarget === '$end') {
      this.set('pageIndex', this.assessmentSteps.length);
      this.set('hideNav', true);
      found = true;
      // Else, find the jumpTarget in assessmentSteps and jump there
    } else {
      for (const key in this.assessmentSteps) {
        // If the iterated step has a uid and it is equal to the jump target (backwards compatibility: or the step's id is equal to the jumpTarget)
        if (this.assessmentSteps[key].uid == jumpTarget || this.assessmentSteps[key]._id == jumpTarget) {
          this.set('pageIndex', key);
          this.set('hideNav', true);
          found = true;
          break;
        }
      }
    }
    // If we found our target, splice the currentPath array to the new index (otherwise, post a warning in the console)
    if (found) this.set('stepHistory', this.currentPath.slice(0, this.currentPath.findIndex((i) => i == this.pageIndex) + 1));
    else console.warn('Could not find jump target: ' + jumpTarget);
  }

  _updateShadow() {
    // Try to get the step ID (and short circuit if we didn't get it)
    const stepId = this.assessmentSteps[this.pageIndex]?._id;
    if (!stepId || !this.panelIsOpen) return;

    // Otherwise, get the scroll element, and its scroll top and bottom
    /** @type {HTMLElement|null} */
    const scrollElement = this.shadowRoot?.querySelector(`#step_${stepId} .inputScroll`) ?? null;
    if (!scrollElement) return;

    const scrollTop = scrollElement.scrollTop;
    const scrollBottom = scrollElement.scrollHeight - (scrollTop + scrollElement.offsetHeight);
    const previousSibling = /** @type {HTMLElement} */ (scrollElement.previousElementSibling);
    const nextSibling = /** @type {HTMLElement} */ (scrollElement.nextElementSibling);
    // If we don't have the siblings, return
    if (!previousSibling || !nextSibling) return;

    // Calculate the shadow opacities
    const scrollShadowHeight = previousSibling?.offsetHeight;
    const scrollShadowTopOpacity = Clamp(scrollTop, 0, scrollShadowHeight) / scrollShadowHeight;
    const scrollShadowBottomOpacity = Clamp(scrollBottom, 0, scrollShadowHeight) / scrollShadowHeight;

    // Set the opacities
    previousSibling.style.opacity = String(scrollShadowTopOpacity);
    nextSibling.style.opacity = String(scrollShadowBottomOpacity);
  }
}

customElements.define('assess-attributes', AssessAttributes);
